export default __webpack_public_path__ + "static/itpodnik-example2-f690fdc21ad9a1ac938eeaf4cf6ff31c.png";